<template>
  <transition
    :css="editorDrawersAreAnimated"
    name="editor-drawer-transition"
    enter-from-class="editor-drawer-transition--enter-from"
    enter-active-class="editor-drawer-transition--enter-active"
    leave-active-class="editor-drawer-transition--leave-active"
    leave-to-class="editor-drawer-transition--leave-to"
    @after-enter="afterEnter"
    @after-leave="afterLeave"
  >
    <div
      v-show="drawerOpen"
      class="editor-drawer add-module-drawer"
      :class="drawerOpen && 'add-module-drawer--open'"
    >
      <div
        :aria-hidden="(!drawerOpen).toString()"
        class="editor-drawer__scroll-wrap"
      >
        <div class="editor-drawer__heading-wrapper">
          <h2 class="editor-drawer__heading">
            {{ $t('Select to Add') }}
          </h2>
          <NebulaButton
            v-if="!alwaysOpen"
            ref="closeButton"
            class="editor-drawer__toggle-button editor-drawer__toggle-button--add"
            aria-expanded="true"
            :aria-label="$t('Close')"
            :disabled="!drawerOpen"
            icon-left="x"
            size="s"
            type="flat"
            @click="toggleDrawer"
          />
        </div>
        <AddModule
          :canvas-name="canvasName"
          :scale="scale"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import { NebulaButton } from '@discoveryedu/nebula-components';
import { mapActions, mapState } from 'pinia';
import * as types from '@/lib/constants/store';
import AddModule from '@/components/AddModule.vue';
import {
  useEditorStore,
} from '@/stores';

export default {
  name: 'AddModuleDrawer',
  components: {
    AddModule,
    NebulaButton,
  },
  props: {
    canvasName: {
      type: String,
      default: 'modules',
    },
    alwaysOpen: {
      type: Boolean,
      default: false,
    },
    scale: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    drawerOpen() {
      if (!this.alwaysOpen) {
        this.$nextTick(() => {
          this.$refs.closeButton.$el.focus();
        });
      }
    },
  },
  computed: {
    ...mapState(useEditorStore, [
      'currentModalCanvasId',
      'editorDrawers',
      'editorDrawersAreAnimated',
      'addModuleDrawerIsOpen',
    ]),
    drawerOpen() {
      return this.alwaysOpen || this.editorDrawers.addModule;
    },
  },
  mounted() {
    if (this.drawerOpen && !this.addModuleDrawerIsOpen) {
      this[types.SET_ADD_MODULE_DRAWER_IS_OPEN](true);
    }
  },
  methods: {
    ...mapActions(useEditorStore, [
      types.TOGGLE_EDITOR_DRAWER,
      types.SET_ADD_MODULE_DRAWER_IS_OPEN,
    ]),
    async toggleDrawer() {
      await this[types.TOGGLE_EDITOR_DRAWER]({
        drawer: 'addModule',
      });
      this.$parent.focusOpen('module');
    },
    afterEnter() {
      this[types.SET_ADD_MODULE_DRAWER_IS_OPEN](true);
    },
    afterLeave() {
      this[types.SET_ADD_MODULE_DRAWER_IS_OPEN](false);
    },
  },
};
</script>

<style lang="stylus">
.add-module-drawer {
  .editor-drawer__heading-wrapper {
    border-bottom: $comet-border-hairline-on-light;
  }
}
</style>
